import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { AccountProvider, AppProvider, AuthProvider, ProfileProvider, ThemeProvider } from './contexts'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from './lib/queryClient'
import { Toaster } from 'sonner'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ProfileProvider>
            <AppProvider>
              <AccountProvider>
                <ThemeProvider>
                <>
                  <App />
                  <Toaster position="top-right" richColors closeButton />
                </>
                </ThemeProvider>
              </AccountProvider>
            </AppProvider>
          </ProfileProvider>
        </AuthProvider>
      </BrowserRouter>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom" />
      )}
    </QueryClientProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// Register service worker for offline functionality and caching
// Only runs in production builds
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('[IoAg] Service worker registered successfully. Content is cached for offline use.')
  },
  onUpdate: (registration) => {
    console.log('[IoAg] New version available! Please close all tabs and reopen to update.')
    // Optional: Show user notification about update
    // You can dispatch an event here to show a toast notification
  }
})
